import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useToasts } from 'react-toast-notifications';
import H1 from 'components/H1';
import H2 from 'components/H2';
import { Flex, Box } from 'rebass';
import peopleServices from 'services/people';
import services from 'services/services';
import helpers from 'utils/helpers';
import { CURRENCY_SYMBOL } from 'utils/constants';

import AppPageWrapper from 'components/AppPageWrapper';
import AppPageWrapperSectionHeader from 'components/AppPageWrapper/AppPageWrapperSectionHeader';
import AppPageWrapperSectionBody from 'components/AppPageWrapper/AppPageWrapperSectionBody';
import ParticipantsPageSubNav from 'containers/ParticipantsPage/ParticipantsPageSubNav';
import AppPageWrapperSectionSubHeader from 'components/AppPageWrapper/AppPageWrapperSectionSubHeader';
import AppPageSubnav from 'components/AppPageWrapper/AppPageSubnav';
import ListWrapper from 'components/ListWrapper';
import ItemWrapper from 'components/ItemWrapper';

function ParticipantsIncentivesPage() {
    const [studyPeoplePaid, setStudyPeoplePaid] = useState([]);
    const { addToast } = useToasts();

    useEffect(() => {
        getPanelIncentivesXHR();
    }, []);

    function renderRows() {
        const render = [];
        studyPeoplePaid.forEach(sp => {
            render.push(
                <ItemWrapper style={{ color: 'black' }} key={sp.id}>
                    <Box width={2 / 5}>
                        <Link className="muted" to={`/participants/${sp.person.id}`}>
                            {helpers.personGetFullName(sp.person)}
                        </Link>
                    </Box>
                    <Box width={2 / 5}>
                        <Link className="muted" to={`/studies/${sp.study.id}`}>
                            {sp.study.title}
                        </Link>
                    </Box>
                    <Box width={1 / 5}>{CURRENCY_SYMBOL[sp.incentive_currency]}{sp.incentive_total_paid}</Box>
                </ItemWrapper>
            );
        });
        return render;
    }

    function getPanelIncentivesXHR() {
        peopleServices
            .getPanelIncentives()
            .then(spp => {
                setStudyPeoplePaid(spp);
            })
            .catch(error => {
                const errorText = services.parseXhrErrors(error);

                addToast(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }
    return (
        <Flex style={{ width: '100%' }}>
            <AppPageWrapper>
                <Helmet>
                    <title>Panel - Incentives Paid</title>
                </Helmet>

                <AppPageSubnav>
                    <ParticipantsPageSubNav/>
                </AppPageSubnav>

                <AppPageWrapperSectionHeader className='experience'>
                    <Box><H1>Panel Incentives Paid</H1></Box>
                </AppPageWrapperSectionHeader>
                <AppPageWrapperSectionBody>
                    <Box mx={4} my={3} width="100%">
                        <H2>Latest 100 panelists paid</H2>
                        <ListWrapper
                            style={{
                                position: 'relative',
                                border: '1px solid #eee',
                                borderRadius: '4px'
                            }}
                        >
                            <ItemWrapper style={{ fontWeight: 500 }}>
                                <Box width={2 / 5}>Name</Box>
                                <Box width={2 / 5}>Study</Box>
                                <Box width={1 / 5}>Paid</Box>
                            </ItemWrapper>
                            {renderRows()}
                            <ItemWrapper style={{ border: 0 }}>
                                {studyPeoplePaid.length} result{studyPeoplePaid.length == 1 ? '' : 's'}
                            </ItemWrapper>
                        </ListWrapper>
                        <br />
                        <br />
                    </Box>
                </AppPageWrapperSectionBody>
            </AppPageWrapper>
        </Flex>
    );
}

export default ParticipantsIncentivesPage;
